import React from 'react'
import { Icon, Tag } from 'antd'
import { transitions } from '../../helper/data.video'

const TransitionDisplay = ({ type, onRemove }) => {
    const transition = transitions.find(t => t.id === type) || null

    if (!transition) {
        return <Icon type="plus" className="video-transition-icon" />
    }

    return (
        <div className="selected-transition">
            <h3>Transition</h3>

            <Tag
                closable
                onClose={e => {
                    e.preventDefault()
                    onRemove(type)
                }}
                className="selected-transition__tag"
            >
                <Icon type={transition.icon} className="video-transition-icon" />
                {transition.name}
            </Tag>
        </div>
    )
}

export default TransitionDisplay;